<template>
    <router-view />
</template>
<style>
    @import url("./assets/css/style.css");
</style>
<script lang="ts">
</script>
